'use client'

import React from 'react'

import DatePicker from '@/src/shared/ui/inputs/date-picker'

import * as UI from './form-fields.styled'
import {RequiredInputMarkIfNeed} from '@/src/shared/ui/inputs/input'
import {Label} from '@/src/shared/ui/label'

export type ContactFieldsData = {
  phone: string
  email: string
  birthday: string
}

export interface Props {
  className?: string
}

export const ContactFields = (props: Props) => {
  return (
    <UI.Wrapper className={props.className}>
      <UI.Phone name="phone" placeholder="Телефон" disabled>
        Телефон
      </UI.Phone>

      <UI.Input name="email" placeholder="Эл. почта" required>
        Эл. почта
      </UI.Input>

      {/*TODO: handleDateValue, defaultDateValue!!! */}
      <UI.DatePicker name="birthday" as={DatePicker} format="DD.MM.YYYY г." required>
        <Label>
          <RequiredInputMarkIfNeed required>Дата рождения</RequiredInputMarkIfNeed>
        </Label>
        &nbsp;
      </UI.DatePicker>
    </UI.Wrapper>
  )
}
